import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';

export enum PricingAnalyticsFeature {
  EvaluationForms = 'EvaluationForms',
  Questionnaires = 'Questionnaires',
  Scheduler = 'Scheduler',
  SendLater = 'SendLater',
  AutomatedActions = 'AutomatedActions',
  Reports = 'Reports',
  ScreeningQuestions = 'ScreeningQuestions',
  PipelineTemplates = 'PipelineTemplates',
  ProfileFieldsTemplates = 'ProfileFieldsTemplates',
  Visibility = 'Visibility',
  CustomDomain = 'CustomDomain',
  Multilang = 'Multilang',
  Roles = 'Roles',
  PersonalAPIToken = 'PersonalAPIToken',
  SSO = 'SSO',
  AdvancedReports = 'AdvancedReports',
  ReportsBuilderLaunch = 'ReportsBuilderLaunch',
  OverdueCandidates = 'OverdueCandidates',
  GDPRAutomations = 'GDPRAutomations',
  AuditLogs = 'AuditLogs',
  Webhooks = 'Webhooks',
  MeetingRooms = 'MeetingRooms',
  JobScheduler = 'JobScheduler',
  ProfilePrint = 'ProfilePrint',
  EEO = 'EEO',
  NotificationsPerRole = 'notificationsPerRole',
  FairEvaluations = 'fairEvaluations',
  KnockoutQuestions = 'knockoutQuestions',
}

@Injectable({ providedIn: 'root' })
export class PricingAnalyticsService extends AnalyticsBase {
  public readonly namespace = 'Pricing';
  public readonly requireViewContext = false;

  public trackFeatureDiscriminated(relatedFeature: PricingAnalyticsFeature) {
    this.track('FeatureDiscriminated', { relatedFeature });
  }

  public trackUpgradeCTAClick(relatedFeature: PricingAnalyticsFeature) {
    this.track('UpgradeCTAClick', { relatedFeature });
  }

  public trackUpgradeFromHeader() {
    this.track('UpgradeFromHeader');
  }
}
